import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function AudienceSection() {
  const isFor = ["Personas de 30+ años que sienten que su metabolismo se ha 'bloqueado'.", 'Profesionales con altos niveles de estrés que sufren de pesadez vespertina.', 'Quienes despiertan con el vientre plano pero terminan el día con dolor abdominal.', 'Personas que buscan una solución rápida pero basada en la bioquímica, no en mitos.'];
  const notFor = ["Personas que buscan una 'pastilla mágica' sin cambiar lo que ponen en su plato por 3 días.", 'Atletas de alto rendimiento en periodos de competición extrema.', 'Quienes prefieren seguir contando calorías en lugar de entender su inflamación.'];
  return <section className="bg-[#FDFAF5] py-20 px-4" data-id="element-1">
      <div className="max-w-[800px] mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3">
          <FadeIn data-id="element-4">
            <div className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-[#2D5A27] h-full" data-id="element-5">
              <h3 className="text-2xl font-bold text-[#1A1A1A] mb-6" data-id="element-6">
                Esto ES para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-7">
                {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-8">
                    <CheckCircle className="w-6 h-6 text-[#4A7C42] flex-shrink-0 mt-0.5" data-id="element-9" />
                    <span className="text-[#5A5A5A] leading-relaxed" data-id="element-10">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-11">
            <div className="bg-gray-50 p-8 rounded-3xl shadow-sm border-t-4 border-gray-300 h-full" data-id="element-12">
              <h3 className="text-2xl font-bold text-[#1A1A1A] mb-6" data-id="element-13">
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-14">
                {notFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-15">
                    <XCircle className="w-6 h-6 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-16" />
                    <span className="text-[#5A5A5A] leading-relaxed" data-id="element-17">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}